<template>
  <!-- Modal para emissão de atestado -->
  <div v-if="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-11/12 max-w-4xl h-5/6 flex flex-col overflow-hidden">
      <!-- Cabeçalho do modal -->
      <div class="px-6 py-4 border-b dark:border-gray-700 flex-shrink-0">
        <div class="flex justify-between items-start mb-2">
          <div class="flex-1">
            <h3 class="text-lg font-bold text-gray-800 dark:text-white">
              Atestado Médico - {{ paciente?.nome }}
            </h3>
            <p class="text-sm text-gray-600 dark:text-gray-300">
              ID: {{ paciente?.idPaciente }} | Acesso: {{ paciente?.numAcesso }} | Data: {{ formatarDataExame(paciente?.data) }}
            </p>
          </div>
          <button @click="fecharModal" class="text-gray-500 hover:text-gray-700 dark:text-white dark:hover:text-gray-300">
            <X class="h-6 w-6" />
          </button>
        </div>
      </div>

      <!-- Conteúdo do modal -->
      <div class="flex flex-1 overflow-hidden min-h-0">
        <!-- Editor de atestado -->
        <div class="w-full p-4 flex flex-col h-full">
                     <div class="flex justify-between items-center mb-4">
             <h4 class="font-bold text-gray-800 dark:text-white">Atestado Médico</h4>
           </div>

          <!-- Formulário do atestado -->
          <div class="flex-1 flex flex-col space-y-4">
            <!-- Informações do paciente -->
            <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
              <h5 class="font-medium text-gray-900 dark:text-white mb-3">Informações do Paciente</h5>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div>
                  <span class="font-medium text-gray-700 dark:text-gray-300">Nome:</span>
                  <p class="text-gray-900 dark:text-white">{{ paciente?.nome }}</p>
                </div>
                <div>
                  <span class="font-medium text-gray-700 dark:text-gray-300">Data de Nascimento:</span>
                  <p class="text-gray-900 dark:text-white">{{ formatarDataNascimento(paciente?.dataNascimento) }}</p>
                </div>
                <div>
                  <span class="font-medium text-gray-700 dark:text-gray-300">CPF:</span>
                  <p class="text-gray-900 dark:text-white">{{ formatarCPF(paciente?.cpf) }}</p>
                </div>
                <div>
                  <span class="font-medium text-gray-700 dark:text-gray-300">Data do Atendimento:</span>
                  <p class="text-gray-900 dark:text-white">{{ formatarDataExame(paciente?.data) }}</p>
                </div>
              </div>
            </div>

            <!-- Duração do atestado -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Duração do Atestado
                </label>
                <div class="flex space-x-2">
                  <input v-model="duracaoAtestado" type="number" min="1" max="365"
                    class="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Dias">
                  <select v-model="tipoDuracao"
                    class="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    <option value="dias">Dias</option>
                    <option value="semanas">Semanas</option>
                    <option value="meses">Meses</option>
                  </select>
                </div>
              </div>
              
                             <div>
                 <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                   Data de Início
                 </label>
                 <input v-model="dataInicio" type="date" readonly
                   class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-600 text-gray-900 dark:text-white">
               </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Data de Término
                </label>
                <input v-model="dataTermino" type="date" readonly
                  class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-600 text-gray-900 dark:text-white">
              </div>
            </div>

            <!-- Motivo do atestado -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Motivo do Atestado
              </label>
              <select v-model="motivoAtestado"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option value="">Selecione o motivo</option>
                <option value="doenca">Doença</option>
                <option value="acidente_trabalho">Acidente de Trabalho</option>
                <option value="acidente_pessoal">Acidente Pessoal</option>
                <option value="licenca_maternidade">Licença Maternidade</option>
                <option value="licenca_paternidade">Licença Paternidade</option>
                <option value="doenca_ocupacional">Doença Ocupacional</option>
                <option value="outros">Outros</option>
              </select>
              
              <!-- Campo para motivo personalizado quando "Outros" for selecionado -->
              <div v-if="motivoAtestado === 'outros'" class="mt-3">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Especificar Motivo
                </label>
                <input v-model="motivoPersonalizado" type="text"
                  class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Digite o motivo específico do atestado">
              </div>
            </div>

            <!-- Editor de conteúdo -->
            <div class="flex-1 flex flex-col">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Conteúdo do Atestado
              </label>
              <div class="flex-1 border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden">
                <textarea
                  v-model="conteudoAtestado"
                  class="w-full h-full p-4 bg-white dark:bg-gray-700 text-gray-900 dark:text-white resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Digite o conteúdo do atestado médico aqui..."
                ></textarea>
              </div>
              <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                Caracteres: {{ contadorCaracteres }}
              </div>
            </div>
          </div>

                     <!-- Controles -->
           <div class="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700">
             <button @click="fecharModal"
               class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">
               Cancelar
             </button>
             
             <button @click="imprimirAtestado"
               :disabled="salvandoAtestado || !conteudoAtestado.trim()"
               class="px-4 py-2 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg transition-colors">
               <span v-if="salvandoAtestado">Imprimindo...</span>
               <span v-else>Imprimir</span>
             </button>
           </div>
        </div>
      </div>
    </div>

    <!-- Banner Message -->
    <BannerMessage
      v-if="showBannerMessage"
      :type="bannerType"
      :message="bannerMessage"
      @close="showBannerMessage = false"
      style="z-index: 999999;"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits, onMounted } from 'vue';
import { X } from 'lucide-vue-next';
import BannerMessage from '@/components/BannerMessage.vue';
import apiClient from '@/services/authService';

// Props
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  paciente: {
    type: Object,
    default: null
  }
});

// Emits
const emit = defineEmits(['close']);

// Estado reativo
const conteudoAtestado = ref('');
const duracaoAtestado = ref('');
const tipoDuracao = ref('dias');
const dataInicio = ref('');
const dataTermino = ref('');
const motivoAtestado = ref('');
const motivoPersonalizado = ref('');
const salvandoAtestado = ref(false);

// Estados de loading
const carregandoAtestado = ref(false);

// Banner
const showBannerMessage = ref(false);
const bannerMessage = ref('');
const bannerType = ref('error');



// Computed
const contadorCaracteres = computed(() => {
  if (!conteudoAtestado.value) return 0;
  const textOnly = conteudoAtestado.value.replace(/<[^>]*>/g, '');
  return textOnly.length;
});

// Watchers
watch(() => props.isVisible, async (novoValor) => {
  if (novoValor && props.paciente) {
    await carregarDadosIniciais();
  }
});

watch(() => props.paciente, async (novoPaciente) => {
  if (novoPaciente && props.isVisible) {
    await carregarDadosIniciais();
  }
});

// Watcher para calcular data de término
watch([duracaoAtestado, tipoDuracao], ([duracao, tipo]) => {
  if (duracao) {
    const dataAtual = new Date();
    let diasAdicionar = parseInt(duracao);
    
    if (tipo === 'semanas') {
      diasAdicionar *= 7;
    } else if (tipo === 'meses') {
      diasAdicionar *= 30; // Aproximação
    }
    
    const dataTerminoObj = new Date(dataAtual);
    dataTerminoObj.setDate(dataTerminoObj.getDate() + diasAdicionar - 1); // -1 para incluir o dia atual
    
    dataTermino.value = dataTerminoObj.toISOString().split('T')[0];
    dataInicio.value = dataAtual.toISOString().split('T')[0];
  }
});

// Lifecycle hooks
onMounted(async () => {
  if (props.isVisible && props.paciente) {
    await carregarDadosIniciais();
  }
});



// Métodos
async function carregarDadosIniciais() {
  if (!props.paciente) return;
  
  carregandoAtestado.value = true;
  try {
    // Definir data de início como hoje
    dataInicio.value = new Date().toISOString().split('T')[0];
    
    // Aplicar template padrão
    setTimeout(() => {
      aplicarTemplatePadrao();
    }, 200);
    
  } catch (error) {
    console.error('Erro ao carregar dados iniciais:', error);
    showBanner('error', 'Erro ao carregar dados do atestado');
  } finally {
    carregandoAtestado.value = false;
  }
}



function aplicarTemplatePadrao() {
  const dataAtual = new Date().toLocaleDateString('pt-BR');
  const nomePaciente = props.paciente?.nome || 'Paciente';
  
  conteudoAtestado.value = `ATESTADO MÉDICO

Atesto para os devidos fins que o(a) paciente ${nomePaciente} compareceu a esta unidade médica em ${dataAtual} para atendimento médico.

Após avaliação clínica, foi constatado que o(a) paciente necessita de afastamento de suas atividades laborais por {{DURACAO}} {{TIPO_DURACAO}}, a partir de {{DATA_INICIO}} até {{DATA_TERMINO}}.

Motivo: {{MOTIVO_ATESTADO}}

Este atestado é válido para apresentação junto ao empregador e/ou órgãos competentes.`;
}



async function imprimirAtestado() {
  if (!conteudoAtestado.value.trim()) {
    showBanner('error', 'Preencha o conteúdo do atestado');
    return;
  }
  
  salvandoAtestado.value = true;
  try {
           // Buscar dados da clínica para as logos
       let clinicData = null;
       let reportLogoBase64 = null;
       let defaultLogoBase64 = null;
       try {
         const clinicResponse = await apiClient.get('/api/v1/clinicsettings/');
         clinicData = clinicResponse.data;
         
         // Buscar logo padrão em base64
         try {
           const defaultLogoResponse = await apiClient.get('/api/v1/clinicsettings/default_logo/');
           defaultLogoBase64 = defaultLogoResponse.data.logo_base64;
         } catch (error) {
           console.warn('Logo padrão não disponível:', error);
         }
         
         // Buscar logo da saúde pública em base64
         try {
           const logoResponse = await apiClient.get('/api/v1/clinicsettings/report_logo/');
           console.log('Logo response:', logoResponse.data);
           reportLogoBase64 = logoResponse.data.logo_base64;
           if (!reportLogoBase64) {
             console.warn('Logo base64 está vazio');
           } else {
             console.log('Logo base64 carregada com sucesso, tamanho:', reportLogoBase64.length);
           }
         } catch (error) {
           console.warn('Logo do relatório não disponível, usando logo padrão:', error);
         }
    } catch (error) {
      console.warn('Erro ao buscar dados da clínica:', error);
      clinicData = {
        nome: 'Clínica',
        logo: '/styles/public/logo.png',
        telefone: '(11) 99999-9999'
      };
    }

    // Prepare the content with placeholders replaced
    let finalConteudoAtestado = conteudoAtestado.value;
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{DURACAO}}/g, duracaoAtestado.value);
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{TIPO_DURACAO}}/g, tipoDuracao.value);
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{DATA_INICIO}}/g, formatarDataExame(dataInicio.value));
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{DATA_TERMINO}}/g, formatarDataExame(dataTermino.value));
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{MOTIVO_ATESTADO}}/g, getMotivoLabel(motivoAtestado.value));
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{NOME_PACIENTE}}/g, props.paciente?.nome || 'Paciente');
    finalConteudoAtestado = finalConteudoAtestado.replace(/{{DATA_ATENDIMENTO}}/g, formatarDataExame(props.paciente?.data));

    const printWindow = window.open('', '_blank');
    const conteudoImpressao = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>ATESTADO MÉDICO - ${props.paciente?.nome}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            color: #000;
            margin: 0;
            padding: 15px;
            background: #fff;
            font-size: 9px;
          }

          .container {
            border: 1px solid #000;
            padding: 5px;
          }

          /* --- HEADER --- */
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px solid #000;
            padding-bottom: 5px;
            margin-bottom: 5px;
          }
          .header-logo {
            max-height: 40px;
          }
          .header-title {
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            flex-grow: 1;
          }

          /* --- TOP INFO BOX --- */
          .id-box-container {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 5px;
          }
          .id-box {
            border: 1px solid #000;
            padding: 2px 4px;
            text-align: center;
            margin-left: 10px;
          }
          .id-box .label {
            font-size: 8px;
            font-weight: bold;
            display: block;
          }
          .id-box .value {
            font-size: 11px;
            font-weight: bold;
          }
          
          /* --- FLEX-GRID LAYOUT --- */
          .flex-grid {
            border-top: 2px solid #000;
            border-bottom: 2px solid #000;
            margin-bottom: 10px;
          }
          .flex-row {
            display: flex;
            border-bottom: 1px solid #000;
          }
          .flex-row:last-child {
            border-bottom: none;
          }
          .flex-item {
            padding: 3px 5px;
            border-left: 1px solid #000;
          }
          .flex-item:first-child {
            border-left: none;
          }
          .item-label {
            font-size: 7px;
            font-weight: bold;
            color: #333;
            display: block;
            margin-bottom: 2px;
            text-transform: uppercase;
          }
          .item-value {
            font-size: 11px;
            font-weight: bold;
          }

          /* --- ATESTADO CONTENT --- */
          .atestado-content {
            margin-top: 15px;
            padding: 10px;
            border: 1px solid #000;
            background-color: #f9f9f9;
          }
          .atestado-title {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 15px;
            text-transform: uppercase;
          }
          .atestado-text {
            font-size: 11px;
            line-height: 1.4;
            text-align: justify;
            margin-bottom: 20px;
          }

                     /* --- SIGNATURE SECTION --- */
           .signature-section {
             margin-top: 30px;
             display: flex;
             justify-content: center;
           }
           .signature-box {
             text-align: center;
             width: 50%;
           }
          .signature-line {
            border-top: 1px solid #000;
            margin-bottom: 5px;
            height: 40px;
          }
                     .signature-text {
             font-size: 9px;
             font-weight: bold;
           }

           /* --- FOOTER --- */
           .footer {
             margin-top: 20px;
             text-align: center;
             border-top: 1px solid #000;
             padding-top: 10px;
           }
           .footer-text {
             font-size: 10px;
             font-weight: bold;
             color: #333;
           }

           /* --- PRINT CONTROLS --- */
          .no-print {
            margin-top: 30px;
            text-align: center;
          }
          .no-print button {
            margin: 0 10px;
            padding: 8px 16px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .no-print button:hover {
            background-color: #0056b3;
          }

          @media print {
            .no-print {
              display: none;
            }
          }
        </style>
      </head>
      <body>
                 <div class="container">
                      <div class="header">
            ${defaultLogoBase64 ? `<img src="data:image/png;base64,${defaultLogoBase64}" alt="Inovamed Logo" class="header-logo" style="max-height: 25px;">` : `<img src="${getClinicLogoUrl(clinicData)}" alt="Inovamed Logo" class="header-logo" style="max-height: 25px;">`}
            <div class="header-title">ㅤㅤㅤATESTADO MÉDICO</div>
            <div>
                ${reportLogoBase64 ? `<img src="data:image/png;base64,${reportLogoBase64}" alt="Saúde Pública Logo" class="header-logo" style="display: block; margin-bottom: 2px; max-height: 45px;">` : '<div class="header-logo" style="display: block; margin-bottom: 2px; max-height: 45px; background-color: #f0f0f0; border: 1px solid #ccc; text-align: center; line-height: 45px; font-size: 8px; color: #666;">Logo não disponível</div>'}
                
            </div>
        </div>

                     <div class="id-box-container">
             <div class="id-box">
               <span class="label">DATA DO ATENDIMENTO</span>
               <span class="value">${formatarDataExame(props.paciente?.data)}</span>
             </div>
           </div>
          
          <div class="flex-grid">
            <div class="flex-row">
              <div class="flex-item" style="flex-basis: 85%;">
                <span class="item-label">NOME</span>
                <span class="item-value">${props.paciente?.nome || ''}</span>
              </div>
            </div>
            <div class="flex-row">
              <div class="flex-item" style="flex-basis: 25%;">
                <span class="item-label">DURAÇÃO</span>
                <span class="item-value">${duracaoAtestado.value} ${tipoDuracao.value}</span>
              </div>
              <div class="flex-item" style="flex-basis: 25%;">
                <span class="item-label">DATA INÍCIO</span>
                <span class="item-value">${formatarDataExame(dataInicio.value)}</span>
              </div>
              <div class="flex-item" style="flex-basis: 25%;">
                <span class="item-label">DATA TÉRMINO</span>
                <span class="item-value">${formatarDataExame(dataTermino.value)}</span>
              </div>
              <div class="flex-item" style="flex-basis: 25%;">
                <span class="item-label">MOTIVO</span>
                <span class="item-value">${getMotivoLabel(motivoAtestado.value)}</span>
              </div>
            </div>
            <div class="flex-row">
              <div class="flex-item" style="width: 100%;">
                <span class="item-label">EXAME</span>
                <span class="item-value">${props.paciente?.exame || ''}</span>
              </div>
            </div>
          </div>

          <div class="atestado-content">
            <div class="atestado-title">ATESTADO MÉDICO</div>
            <div class="atestado-text">
              ${finalConteudoAtestado.replace(/\n/g, '<br>')}
            </div>
          </div>

                     <div class="signature-section">
             <div class="signature-box">
               <div class="signature-line"></div>
               <div class="signature-text">Assinatura e Carimbo do Médico</div>
             </div>
           </div>
           
           <div class="footer">
             <div class="footer-text">${clinicData.nome}</div>
           </div>
        </div>

        <div class="no-print">
          <button onclick="window.print()">Imprimir</button>
          <button onclick="window.close()">Fechar</button>
        </div>
      </body>
      </html>
    `;
    
    printWindow.document.write(conteudoImpressao);
    printWindow.document.close();
    printWindow.onload = function() { printWindow.print(); };
    showBanner('success', 'Atestado enviado para impressão!');
  } catch (error) {
    console.error('Erro ao imprimir atestado:', error);
    showBanner('error', 'Erro ao imprimir atestado');
  } finally {
    salvandoAtestado.value = false;
  }
}

function fecharModal() {
  // Limpar estados
  conteudoAtestado.value = '';
  duracaoAtestado.value = '';
  tipoDuracao.value = 'dias';
  dataInicio.value = '';
  dataTermino.value = '';
  motivoAtestado.value = '';
  motivoPersonalizado.value = '';
  
  // Limpar banner
  showBannerMessage.value = false;
  bannerMessage.value = '';
  bannerType.value = 'error';
  
  // Emitir evento de fechamento
  emit('close');
}

function showBanner(type, message) {
  bannerType.value = type;
  bannerMessage.value = message;
  showBannerMessage.value = true;
}

// Funções auxiliares
function formatarDataExame(dataString) {
  if (!dataString) return '';
  const date = new Date(dataString);
  return date.toLocaleDateString('pt-BR');
}

function formatarDataNascimento(dataString) {
  if (!dataString) return 'Não informado';
  const date = new Date(dataString);
  return date.toLocaleDateString('pt-BR');
}

function formatarCPF(cpf) {
  if (!cpf) return 'Não informado';
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

 function getMotivoLabel(motivo) {
   const motivos = {
     'doenca': 'Doença',
     'acidente_trabalho': 'Acidente de Trabalho',
     'acidente_pessoal': 'Acidente Pessoal',
     'licenca_maternidade': 'Licença Maternidade',
     'licenca_paternidade': 'Licença Paternidade',
     'doenca_ocupacional': 'Doença Ocupacional',
     'outros': motivoPersonalizado.value || 'Outros'
   };
   return motivos[motivo] || motivo || 'Não especificado';
 }

 function getClinicLogoUrl(clinicData) {
   if (!clinicData || !clinicData.logo) {
     return '/styles/public/logo.png';
   }
   return clinicData.logo.startsWith('http') ? clinicData.logo : `http://localhost:8000${clinicData.logo}`;
 }


</script>

<style scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';
</style> 